import styled from "styled-components";
export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 5.6vh 3.3vw;
`;

// -- start Header -- //

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 3vh;
`;
export const DivIconHead = styled.div`
  height: 3.2vw;
  width: 3.2vw;
  background: ${({ deleteModal }) =>
    deleteModal ? "var(--red)" : "var(--orange)"};
  margin-inline-end: 0.6vw;
  border-radius: 50%;
`;
export const IconHead = styled.img`
  height: 100%;
  filter: brightness(0) invert(1);
`;

export const TitleHead = styled.p`
  color: black;
  font-size: 0.94vw;
  font-weight: 700;
`;

// -- end Header -- //

// -- start Body -- //

export const Body = styled.div`
  padding-top: 5vh;
  width: 100%;
  display: flex;
  column-gap: 4.6vw;
  row-gap: 3vh;
  flex-direction: column;
`;
export const DivText = styled.div`
  width: 19.4vw;
  text-align: justify;
  font-size: 0.94vw;
  font-weight: 600;
`;
export const DeleteElement = styled.span`
  color: var(--red);
  font-weight: 700;
`;
export const DivRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 2vw;
`;
export const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 3vh;
`;

export const DivSelectUser = styled.div`
  width: 19.4vw;
  display: flex;
  flex-direction: row;
  column-gap: 0.7vw;
  align-items: flex-end;
`;
export const CoverImgUser = styled.div`
  height: 6vh;
  width: 6vh;
  background: var(--selectBackground);
  transition: all 0.2s ease-in-out;
  border-radius: 1.6vh;
`;
export const ImgUser = styled.img`
  width: 100%;
  height: 100%;
  ${({ haveAvatar }) => !haveAvatar && "filter: brightness(0) invert(1);"}
`;
export const SelectUser = styled.button`
  height: 6vh;
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: var(--selectBackground);
  color: white;
  font-size: 0.9vw;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  border-radius: 1.6vh;
  border: none;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
export const DivInput = styled.div`
  width: 19.4vw;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
`;
export const CoverImg = styled.div`
  height: 8.4vw;
  width: 8.4vw;
  border: solid 0.1vw var(--inputStroke);
  background: var(--inputBackground);
  border-radius: 1.3vw;
  padding: 0.3vw;
  margin: auto;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 0.7;
  }
`;
export const Img = styled.img`
  height: 100%;
  width: 100%;
  border-radius: 1vw;
`;
export const Input = styled.input`
  padding: 0 1.2vw 0 1.2vw;
  font-size: 0.9vw;
  height: 6vh;
  width: 100%;
  background-color: ${({ disabled }) =>
    disabled ? "#f4f7f7" : "var(--inputBackground)"};
  color: ${({ disabled }) => (disabled ? "#B5B5B5" : "")};
  ${({ disabled }) => disabled && "cursor: not-allowed;"}
  border-radius: 1.6vh;
  border: 0.11vw solid var(--inputStroke);
  margin: 0;
`;
export const Lable = styled.label`
  color: var(--lable);
  font-size: 0.9vw;
  font-weight: 500;
  padding-bottom: 1vh;
  padding-inline-start: 0.5vw;
`;
export const DivInputPassword = styled.div`
  position: relative;
  height: 6vh;
  width: 100%;
  display: flex;
  align-items: center;
`;
export const InputPassword = styled.input`
  padding-inline-start: 1.2vw;
  padding-inline-end: 2.8vw;
  font-size: 0.9vw;
  height: 100%;
  width: 100%;
  background-color: var(--inputBackground);
  border-radius: 1.6vh;
  border: 0.11vw solid var(--inputStroke);
  margin: 0;
`;
export const BtnShowPassword = styled.button`
  height: 100%;
  background: none;
  font-size: 1.7vh;
  align-items: center;
  text-align: center;
  display: flex;
  justify-content: center;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  position: absolute;
  top: 0;
  inset-inline-end: 0.4vw;
  padding: 0 0.5vw;
`;
export const ImgShowPassword = styled.img`
  height: 50%;
`;
export const ActivRoleCheckbox = styled.div`
  height: 1.1vw;
  width: 1.1vw;
  border-radius: 0.5vh;
  border: 0.1vw solid
    ${({ active }) => (active ? "var(--brown)" : "var(--checkboxStroke)")};
  margin-inline-end: 0.6vw;
  background-color: ${({ active }) => (active ? "var(--brown)" : "white")};
  transition: all 0.2s ease-in-out;
  cursor: pointer;
`;
export const DivSelect = styled.div`
  padding: 1vh;
  font-size: 0.9vw;
  height: 57.4vh;
  width: 22.4vw;
  border-radius: 1.6vh;
  border: 0.16vh dashed var(--dashedStroke);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  row-gap: 0.3vw;
  flex-direction: column;
  overflow-x: hidden;
  scrollbar-width: none; /* Firefox */
  &:-ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const DivList = styled.div`
  font-size: 0.9vw;
  height: 100%;
  width: 100%;
  border-radius: 1.6vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 0.4vw;
  overflow-x: hidden;
  &:-ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const ListItems = styled.div`
  position: relative;
  padding: 1vw;
  height: 52.7vh;
  width: 100%;
  border-radius: 1.6vh;
  background: var(--backgroundBoxDetail);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-direction: column;
`;
export const DivPermissions = styled.div`
  font-size: 0.9vw;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.3vw;
  flex-direction: column;
`;
export const DivPermission = styled.div`
  padding: 1vh;
  font-size: 0.9vw;
  height: 4.7vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.3vw;
  color: var(--brown);
  font-weight: 700;
`;
export const DashedSubPermissions = styled.div`
  height: 100%;
  border: dashed 0.05vw var(--dashedStroke);
`;
export const DivBoxSubPermissions = styled.div`
  padding-inline-start: 1.6vw;
  padding-block: 0.7vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.8vw;
`;
export const DivSubPermission = styled.div`
  font-size: 0.9vw;
  height: 4vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.3vw;
`;
export const DivSubPermissions = styled.div`
  font-size: 0.9vw;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.3vw;
  flex-direction: column;
  font-weight: 500;
  color: var(--lightBrown);
`;

// -- end Body -- //

// -- start Button -- //

export const Btn = styled.button`
  width: ${({ large }) => (large ? "100%" : "46%;")};
  font-size: 0.9vw;
  border-radius: 1.6vh;
  align-items: center;
  text-align: center;
  color: white;
  display: flex;
  justify-content: center;
  background: ${({ okBtn }) => (okBtn ? "var(--orange)" : "var(--red)")};
  font-weight: 600;
  color: white;
  text-decoration: none;
  padding: 1.5vh 0.3vw;
  transition: all 0.2s ease-in-out;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background: ${({ okBtn }) =>
      okBtn ? "var(--darkOrange)" : "var(--darkRed)"};
    color: white;
  }
`;
export const BtnShowDivPassword = styled.button`
  width: 100%;
  height: 6vh;
  font-size: 0.9vw;
  border-radius: 1.6vh;
  align-items: center;
  text-align: center;
  color: white;
  display: flex;
  justify-content: center;
  background: var(--brown);
  font-weight: 600;
  color: white;
  text-decoration: none;
  padding: 1.5vh 0.3vw;
  transition: all 0.2s ease-in-out;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background: black;
    color: white;
  }
`;

export const BtnDiv = styled.div`
  ${({ btnPadding }) => btnPadding && "padding-top:1.8vh"};
  width: 19.4vw;
  display: flex;
  flex-direction: ${({ rowReverse }) => (rowReverse ? "row-reverse" : "row")};
  align-items: flex-end;
  justify-content: space-between;
`;
export const BtnIcon = styled.img`
  width: 1.2vw;
  margin-left: 0.1vw;
  cursor: pointer;
  border-radius: 0.5vh;
  ${({ hover }) => hover && "&:hover {background-color: #3a7599;}"}
`;
export const User = styled.button`
  width: 100%;
  min-height: 5.6vh;
  padding: 0.4vh 1vw;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  ${({ active }) =>
    active
      ? "background: var(--orange); color:white;"
      : "background: var(--userBackground);color: var(--brown);cursor: pointer;&:hover {opacity: 0.8;}"}

  font-size: 0.9vw;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  border-radius: 0.9vh;
  border: none;
  gap: 0.6vw;
`;
export const DivInputSearch = styled.div`
  width: 22.4vw;
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const InputSearch = styled.input`
  padding-inline-start: 3.4vw;
  padding-inline-end: 1.2vw;
  font-size: 0.9vw;
  height: 6vh;
  width: 100%;
  background-color: ${({ disabled }) =>
    disabled ? "#f4f7f7" : "var(--inputBackground)"};
  color: ${({ disabled }) => (disabled ? "#B5B5B5" : "")};
  ${({ disabled }) => disabled && "cursor: not-allowed;"}
  border-radius: 1.6vh;
  border: 0.11vw solid var(--inputStroke);
  margin: 0;
`;
export const SearchIcon = styled.img`
  position: absolute;
  z-index: 11;
  top: 0;
  marker-start: 0;
  padding-inline-start: 0.4vw;
  height: 100%;
`;
export const CoverImgProfile = styled.div`
  height: 4.8vh;
  width: 4.8vh;
  border: solid 0.1vw var(--inputStroke);
  background: var(--selectBackground);
  transition: all 0.2s ease-in-out;
  border-radius: 0.8vh;
`;
export const ImgProfile = styled.img`
  width: 100%;
  height: 100%;
  ${({ haveAvatar }) => !haveAvatar && "filter: brightness(0) invert(1);"}
`;
// -- end Button -- //
